
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 65","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"32","cy":"32.25","r":"18.029","stroke":"#E6E7E9","stroke-width":"3.943"}}),_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"d":"M32 14.25c0-1.105.898-2.01 1.997-1.9a20.001 20.001 0 11-5.126 39.654 20 20 0 01-15.18-11.706c-.445-1.01.14-2.144 1.19-2.486 1.05-.341 2.168.241 2.637 1.24a16 16 0 1016.477-22.677C32.899 16.237 32 15.355 32 14.25z"}})]),_c('path',{attrs:{"d":"M32 14.25c0-1.105.898-2.01 1.997-1.9a20.001 20.001 0 11-5.126 39.654 20 20 0 01-15.18-11.706c-.445-1.01.14-2.144 1.19-2.486 1.05-.341 2.168.241 2.637 1.24a16 16 0 1016.477-22.677C32.899 16.237 32 15.355 32 14.25z","stroke":"#56BFC7","stroke-width":"6.857","mask":"url(#a)"}})])
          )
        }
      }
    